import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function OAuthOk() {
  const navigate = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    (async () => {
      await refresh();      // fuerza refresco de auth
      navigate("/", { replace: true });
    })();
  }, [navigate, refresh]);

  return (
    <div style={{ padding: 32 }}>
      <h2>Login con Google completado</h2>
      <p>Entrando...</p>
    </div>
  );
}
